import React from "react";
import { Card } from "primereact/card";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ReactComponent as Marker } from "src/assets/icons/marker.svg";
import { ProgressSpinner } from "primereact/progressspinner";
import { isCivilDefenseUser } from "src/utils/helpers";

const DashboardCompanyReviewCard = ({ title = "" }) => {
  const { t } = useTranslation(["common", "dashboard"]);
  const { bmcRatingStatistics } = useSelector((state: any) => state.dashboard);

  const { companyReview } = useSelector(
    (state: any) => state.dashboard.dashboardCardsData
  );
  const isDashboardCardsDataLoaded = useSelector(
    (state: any) => state.dashboard.isDashboardCardsDataLoaded
  );
  const getCompanyReviewPercentage = () => {
    let percentage = 0;
    let ratingText = "";

    if (isCivilDefenseUser()) {
      const bmcRating = bmcRatingStatistics?.averagebmcsRatings;
      if (bmcRating) {
        percentage = bmcRating.ratingPercentage
          ? bmcRating.ratingPercentage
          : 0;
        ratingText = t(bmcRating.ratingText ? bmcRating.ratingText : "");
      }
    } else if (companyReview) {
      // get integer number of companyReview / 5 * 100
      percentage = companyReview?.ratingPercentage
        ? companyReview?.ratingPercentage
        : 0;
      ratingText = t(
        companyReview?.ratingText ? companyReview?.ratingText : ""
      );
    }
    return (
      parseInt(percentage?.toString()) +
      "% (" +
      t(ratingText?.toLowerCase()) +
      ")"
    );
  };
  const getMarkerClass = () => {
    const review = isCivilDefenseUser()
      ? bmcRatingStatistics?.averagebmcsRatings
      : companyReview;
    if (review?.ratingPercentage === 0) {
      return "zero";
    } else if (review?.ratingPercentage === 100) {
      return "hundred";
    } else {
      return review?.ratingText?.toLowerCase();
    }
    //return "zero";
  };
  return (
    <Card className="card card-1-2">
      <div className="card-content">
        <div className="d-flex gap-2 justify-content-start align-items-center">
          <div className="circle inactive p-4 d-flex justify-content-center align-items-center">
            <RateReviewOutlinedIcon />{" "}
          </div>
          <h6 className="card-title">{title}</h6>
        </div>
        {isDashboardCardsDataLoaded && (
          <div className="card-data mt-2">
            <div className="d-flex gap-2 align-items-center justify-content-start">
              <h4>{getCompanyReviewPercentage()}</h4>
            </div>
            <div className="custom-progress-bar d-flex">
              <Marker className={`marker marker-${getMarkerClass()}`} />
              <div className="progress-bar-inner progress-excellent"></div>
              <div className="progress-bar-inner progress-good"></div>
              <div className="progress-bar-inner progress-fair"></div>
              <div className="progress-bar-inner progress-poor"></div>
            </div>
            <div className="d-flex justify-content-between mt-2">
              <span className="fs-10">{t("veryPositive")}</span>
              <span className="fs-10">{t("veryNegative")}</span>
            </div>
          </div>
        )}
        {!isDashboardCardsDataLoaded && <ProgressSpinner />}
      </div>
    </Card>
  );
};

export default DashboardCompanyReviewCard;
